/* ============
 * All Cities
 * ============
 *
 * All cities from a country.
 */

import Vue from 'vue';
import store from './../../store';
import municipalityTransformer from './../../transformers/municipality';

const success = ({ data }, resolve) => {
  const municipalities = municipalityTransformer.fetchCollection(data.data);

  store.dispatch('fetchMunicipalities', { municipalities });
  resolve();
};

const failed = () => {
};

// Display cities related to a municipality.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('municipality')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/municipality/all.js